module.exports = __webpack_public_path__ + "img/power-socket.5c4a70ba.svg";